<template>
  <div class="outer-box restore-Documents">
    <h4>Restore Documents from Location</h4>
    <div v-if="deletedDocumentsFromLocation.length > 0" class="inner-box" style="text-align: left; width: 600px;">
        <button
          class="btn btn-danger mb-4"
          @click="deletedDocumentsFromLocation = []; locationId = ''"
        >Clear / Get from another Location</button>
        <div style="display: flex; align-items: center; margin: 4px">
        <!-- Contact search is now limited by name, due to the way we fetch it from db -->
          <input class="hl_input--wrap" @keypress.enter="searchContacts" type="text" v-model="documentNameSearch" placeholder="Search Document by name">
          <button style="margin-left: 4px" v-if="documentType === 'contact'" class="btn btn-primary" @click="searchContacts">Search</button>
        </div>
        <div>
          <button style="margin: 4px;" :disabled="disabledPrev" class="btn btn-success" @click="prevPage">Prev. page</button>
          <button style="margin: 4px;" :disabled="disabledNext" class="btn btn-success" @click="nextPage">Next page</button>
        </div>
      <div class="document" v-for="document in paginatedFilteredDeletedDocuments" :key="document.id">
        <div class="document-info">
          <h5 v-if="document.first_name" style="margin-bottom: 1px;">{{ document.first_name }}</h5>
          <span v-if="document.last_name" style="margin-bottom: 1px;">{{ document.last_name }}</span>
          <span v-if="document.name" style="margin-bottom: 1px;">{{ document.name }}</span>
          <span v-if="document.phone">{{ document.phone }}</span>
          <span v-if="document.email">{{ document.email }}</span>
          <span>{{ document.id }}</span>
          <span v-if="document.date_updated" style="margin-right: 16px">Date updated: {{ moment.unix(document.date_updated._seconds).utc() }}</span>
        </div>
        <button
          :disabled="restoringDocument.includes(document.id)"
          class="btn btn-primary"
          @click="restoreDocument(document)"
        >
          <moon-loader
            v-if="restoringDocument.includes(document.id)"
            :loading="true"
            size="21px"
            color="#fafafa"
          />
          <span v-else>Restore</span>
        </button>
      </div>
    </div>
    <div v-else class="inner-box" style="text-align: left; width: 600px;">
      <label>Document Type (collection)</label>
      <select
        class="hl_input--wrap"
        type="text"
        v-model="documentType"
      >
        <option value="contact">Contacts</option>
        <option value="pipeline">Pipelines + Opportunities deleted with it</option>
        <!--
          To add another option, first create the endpoints in appengine following this pattern:
          GET /location/:location_id/deleted_{DOCUMENT_TYPE}s
          GET /{DOCUMENT_TYPE}/restore/:{DOCUMENT_TYPE}_id

          Make sure they work correctly for that specific document, then just add an option above
         -->
      </select>
      <label class="mt-4">Location ID</label>
      <input
        class="hl_input--wrap my-1"
        type="text"
        placeholder="Location ID"
        v-model="locationId"
      />
      <button class="btn btn-primary mt-4" @click="getDeletedDocuments">
        <moon-loader v-if="gettingDocuments" :loading="true" size="21px" color="#fafafa" />
        <span v-else>Get Deleted Documents</span>
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import * as _ from 'lodash';
import { SpmAppengineService } from '@/services'

export default {
  data() {
    return {
      locationId: null,
      deletedDocumentsFromLocation: [],
      restoringDocument: [],
      gettingDocuments: false,
      documentNameSearch: '',
      initialIndex: 0,
      documentType: 'contact',
      moment,
      firstDocumentId: null, // For the Contact Paginaton logic
      prevPageIds: [] // For the Contact Paginaton logic
    };
  },
  watch: {
    async documentNameSearch(val) {
      if (val) {
        this.initialIndex = 0
      }
    }
  },
  computed: {
    disabledPrev() {
      if (this.documentType === 'contact') {
        return Boolean(this.deletedDocumentsFromLocation[0].id === this.firstDocumentId)
      } else {
        return Boolean(this.initialIndex <= 0)
      }
    },
    disabledNext() {
      if (this.documentType === 'contact') { // Limit is 10 per page, but we fetch 11 to be able to paginate and know if we have next page
        return Boolean(this.deletedDocumentsFromLocation.length !== 11)
      } else {
        return Boolean(this.initialIndex + 10 >= this.filteredDeletedDocuments.length)
      }
    },
    filteredDeletedDocuments() {
      if (this.documentType !== 'contact' && this.documentNameSearch !== '') {
        const searchLowerCase = this.documentNameSearch.toLowerCase()
        return this.deletedDocumentsFromLocation.filter(document => {
          const fieldsLowercase = `${document.name && document.name.toLowerCase()}` // Add more fields here if necessary (contact search not included)
          return fieldsLowercase.includes(searchLowerCase)
      })
      } else {
        return this.deletedDocumentsFromLocation
      }
    },
    paginatedFilteredDeletedDocuments() {
      return this.filteredDeletedDocuments.slice(this.initialIndex, this.initialIndex + 10)
    }
  },
  methods: {
    async searchContacts() {
      let val = this.documentNameSearch
      this.firstDocumentId = null
      this.prevPageIds = []
      await this.getDeletedDocuments({})
      if (val) { // Check if the searched term is included in the results
        const searchLowerCase = val.toLowerCase()
        if (!this.deletedDocumentsFromLocation.find(document => {
          const fieldsLowercase = `${document.first_name && document.first_name.toLowerCase()} ${document.last_name && document.last_name.toLowerCase()}`
          return fieldsLowercase.includes(searchLowerCase)
        })) {
          alert('The name you are searching for was not found in the deleted contacts of this location. The following names in alphabetical order will be displayed instead.')
        }
      }
    },
    async prevPage() {
      if (this.documentType === 'contact') {
        const firstDocument = this.deletedDocumentsFromLocation[0]
        await this.getDeletedDocuments({ startAfter: this.prevPageIds[this.prevPageIds.length -1], endBefore: firstDocument.id }) // startafter has to be specified or else we will only get first 11 always
        this.prevPageIds.pop() // Remove from array so we dont paginate with it next time
      } else {
        this.initialIndex -= 10
      }
    },
    async nextPage() {
      if (this.documentType === 'contact' && this.deletedDocumentsFromLocation.length === 11) {
        if (this.deletedDocumentsFromLocation.length > 0) this.prevPageIds.push(this.deletedDocumentsFromLocation[0].id) // Add to array for the next pagination to work
        const lastDocument = this.deletedDocumentsFromLocation[this.deletedDocumentsFromLocation.length - 1]
        await this.getDeletedDocuments({ startAfter: lastDocument.id })
      } else {
        this.initialIndex += 10
      }
    },
    async restoreDocument(document) {
      const documentId = document.id
      if (confirm(`Are you certain that ${document.name || document.first_name} needs to be restored? It will take a few minutes for changes to take effect.`)) {
        this.restoringDocument.push(documentId);
        try {
          await SpmAppengineService.restoreDocument(this.documentType, documentId)
          this.deletedDocumentsFromLocation = this.deletedDocumentsFromLocation.filter(document => document.id !== documentId)
        } catch (err) {
          console.error(err);
          alert(`An error has ocurred: ${JSON.stringify(err.message ? err.message : err)}`);
        } finally {
          let index = this.restoringDocument.indexOf(documentId)
          this.restoringDocument.splice(index, 1)
        }
      }
    },
    async getDeletedDocuments({ startAfter, endBefore }) {
      const searchTerm = this.documentType === 'contact' ? this.documentNameSearch : undefined
      this.gettingDocuments = true;
      try {
        const response = await SpmAppengineService.getDeletedDocuments(
          this.locationId,
          this.documentType,
          {
            startAfter,
            endBefore,
            searchTerm,
          }
        );
        this.deletedDocumentsFromLocation = response.data // Ordering is done by backend
        if (!this.firstDocumentId) this.firstDocumentId = this.deletedDocumentsFromLocation[0].id // Used to disable Previous button
      } catch (err) {
        console.error(err);
        alert(`An error has ocurred: ${JSON.stringify(err.message ? err.message : err)}`);
      } finally {
        this.gettingDocuments = false;
      }
    },
  }
}
</script>

<style>
.document {
  border-bottom: 0.5px solid #ddd;
  padding: 16px;
  display: flex;
  justify-content: space-between;
}
.document:last-child {
  border-bottom: none;
}
.document-info {
  font-size: 10pt;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-bottom: 8px;
}
.restore-Documents {
  min-width: 40vw;
}
</style>
